import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PdfStyle } from './pdf-style';
import { ApiService } from './services/api/api.service';

@Injectable({
    providedIn: 'root',
})
export class PdfStyleService {
    constructor(private apiService: ApiService) {}

    public getStyles(): Observable<PdfStyle[]> {
        return this.apiService.getCall$<PdfStyle[]>('pdf-styles').pipe(map(response => response.data));
    }

    public applyPrimaryColor(style: PdfStyle | null): void {
        const color = style?.primary_color;
        if (color && /^#[0-9a-fA-F]{3,8}$|^rgba?\(|^hsla?\(|^[a-z]{1,30}$/.test(color)) {
            document.documentElement.style.setProperty('--pdf-primary-color', color);
        }
    }
}
